<template>
    <rkm-modal
        :loading="loading"
        persistent
        ref="Modal"
        title="Motivo"
    >
        <rkm-form ref="Form">
            <rkm-row>
                <rkm-col>
                    <template v-if="readonly">
                        {{ motivo }}
                    </template>

                    <rkm-form-textarea
                        v-else
                        :maxlength="validations.motivo.max"
                        :validations="validations.motivo"
                        v-model="motivo"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer>
            <rkm-button
                v-if="readonly"
                :disabled="!!loading"
                @click="$refs.Modal.hide()"
            >
                Fechar
            </rkm-button>

            <rkm-button
                v-else
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                v-if="!readonly"
                :disabled="!!loading"
                @click="$refs.Form.validate(save)"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        validations() {

            return {
                motivo: {
                    required: true,
                    max: 300,
                }
            }
        }
    },
    data: () => ({
        item: {},
        motivo: null,
        readonly: false,
    }),
    methods: {
        open(item, readonly) {

            this.item = item
            this.readonly = readonly

            this.motivo = item.motivoOutro

            this.$refs.Modal.show()
        },
        cancel() {

            if (!this.item.motivoOutro) {

                this.item.motivoId = null
            }

            this.$refs.Modal.hide()
        },
        save() {

            this.item.motivoOutro = this.motivo

            this.$refs.Modal.hide()
        },
    },
}
</script>